// @flow
import * as React from 'react';
import Logging from '@ta/common.logging';
import routerContext from './RouterContext';

const useLocationDetail = (): ?number => {
  const {
    route: { detail },
  } = React.useContext(routerContext);
  try {
    return parseInt(detail, 10);
  } catch (e) {
    Logging.error('Could not parse detail parameter as a number', e);
    return null;
  }
};

export default useLocationDetail;
